export default __webpack_public_path__ + "e3ae9343ea257dfd9be4e66657243e15.svg";